import { Divider, Typography } from "@mui/material";

function SubmitReimbursementHeader() {
  return (
    <>
      <Typography variant="h2" sx={{ pb: { xs: 0, sm: 2 }, fontSize: { xs: "1.4rem", sm: "1.8rem" } }}>
        Submit a Reimbursement Request
      </Typography>
      <Divider sx={{ backgroundColor: "brightOrange.main" }} />
      <Typography variant="body1" sx={{ pb: 2, fontSize: { xs: "0.8rem", sm: "1rem" } }}>
        You are able to use your When Benefit to get reimbursed for the premiums for the health insurance policy you
        select. All you need to do is submit a reimbursement request with proof of payment.
      </Typography>
    </>
  );
}

export default SubmitReimbursementHeader;